import io from "socket.io-client";
import { ASSESSMENT_URL } from "../../utils/url-builder";

let socket = null;
let isSocketConnected = true;

export const ASSESSMENT_CHANNEL_NAME = {
  ASSESSMENT_PUBLISHED: "ASSESSMENT_PUBLISHED",
  ASSESSMENT_ROLL_BACK: "ASSESSMENT_ROLL_BACK",
};

export const connectToAssessmentSocket = () => {
  if (socket !== null) {
    return;
  }
  const { origin } = new URL(ASSESSMENT_URL);
  const url = `${origin}?access_token=${localStorage.getItem("usertoken")}`;
  socket = io(url, { transports: ["websocket"] });
};

export const disconnectAssessmentSocket = () => {
  if (socket === null) {
    return;
  }
  socket.disconnect();
  socket = null;
  isSocketConnected = false;
};

export const registerAssessmentSocketConnected = (callback) => {
  if (socket === null) {
    console.error("registering assessment connected without initalizing");
    return;
  }
  if (isSocketConnected) {
    callback();
    return;
  }

  socket.on("connect", () => {
    isSocketConnected = true;
    callback();
  });
};

export const registerAssessmentSocketDisconnected = (callback) => {
  if (socket === null) {
    console.error("registering assessment disconnected without initalizing");
    return;
  }
  socket.on("disconnect", (msg) => {
    isSocketConnected = false;
    callback(msg);
  });
};

export const registerAssessmentEvent = (assessmentChannel, callback) => {
  if (socket === null) {
    console.error("registering assessment event");
    return;
  }
  socket.on(assessmentChannel, (msg) => callback(msg));
};

export const sendAssessmentEvent = (assessmentChannel, message) => {
  socket.emit(assessmentChannel, message);
};

export const unRegisterAssessmentEvent = (assessmentChannel, callback) => {
  if (socket === null) {
    return;
  }
  socket.off(assessmentChannel, callback);
};
